module.exports = __webpack_public_path__ + "img/ic_head_voltar.7d447abe.svg";